export default "__VITE_ASSET__CxRRrkaT__"